import ITableSort from "./ITableSort";

export default class TableSort {
	table: ITableSort;
	rotationValue: string;
	sortValue: string;
	sortAscending: boolean;

	constructor(table: ITableSort) {
		this.rotationValue = 'rotate(180deg)';
		this.table = table;
		this.sortValue = "";
		this.sortAscending = false;
	}

	public addSortingIconsClickListeners() {
		const sortIcons: NodeListOf<HTMLImageElement> = document.querySelectorAll('th img');
		sortIcons.forEach(img => {
			img.onclick = () => {
				this.sortValue = img.dataset.value;
				if (this.rotationValue === img.style.transform) {
					//descending
					img.style.transform = '';
					this.sortAscending = false;
					this.table.fetchList();
				} else {
					//ascending
					img.style.transform = this.rotationValue;
					this.sortAscending = true;
					this.table.fetchList();
				}
			}
		});
	}
}
